import { Link, useNavigate } from "react-router-dom";
import "./SiteFooter.css";

function LogoInline({ size = 0.85 }) {
  return (
    <div style={{
      fontFamily: "'Anton', 'Archivo Black', Impact, sans-serif",
      display: "inline-flex",
      alignItems: "center",
      fontSize: `${26 * size}px`,
      letterSpacing: "-0.01em",
      lineHeight: 1,
      fontWeight: 400,
      textTransform: "uppercase",
    }}>
      <span style={{ color: "var(--paper)" }}>ROUGH</span>
      <span style={{
        display: "inline-block",
        width: `${2 * size}px`,
        height: `${20 * size}px`,
        background: "var(--orange)",
        margin: `0 ${8 * size}px`,
        transform: "skewX(-20deg)",
      }} />
      <span style={{ color: "var(--orange)" }}>CUT</span>
    </div>
  );
}

const DISCORD_URL = process.env.REACT_APP_DISCORD_URL || "#";

const COLS = [
  { title: "SECTIONS", items: [{ label: "Latest", to: "/", hash: "latest-cuts" }, { label: "Discover", to: "/discover" }, { label: "Radar", to: "/", hash: "on-the-radar" }] },
  { title: "ABOUT",    items: [{ label: "About",   to: "/about" }, { label: "Contact", to: "/contact" }, { label: "Privacy", to: "/privacy" }] },
];

const linkStyle = {
  display: "block",
  padding: "4px 0",
  color: "var(--paper)",
  fontSize: 14,
  textDecoration: "none",
  transition: "color 0.15s",
  cursor: "pointer",
};

function FooterLink({ item }) {
  const navigate = useNavigate();

  if (item.href) {
    return (
      <a
        href={item.href}
        target="_blank"
        rel="noopener noreferrer"
        style={{ ...linkStyle, display: "flex", alignItems: "center" }}
        onMouseEnter={e => { e.currentTarget.style.color = "var(--orange)"; }}
        onMouseLeave={e => { e.currentTarget.style.color = "var(--paper)"; }}
      >
        {item.icon}
        {item.label}
      </a>
    );
  }

  if (item.hash) {
    const handleClick = (e) => {
      e.preventDefault();
      navigate("/");
      setTimeout(() => {
        document.getElementById(item.hash)?.scrollIntoView({ behavior: "smooth" });
      }, 50);
    };
    return (
      <a
        href={`/#${item.hash}`}
        style={linkStyle}
        onClick={handleClick}
        onMouseEnter={e => { e.currentTarget.style.color = "var(--orange)"; }}
        onMouseLeave={e => { e.currentTarget.style.color = "var(--paper)"; }}
      >
        {item.label}
      </a>
    );
  }

  return (
    <Link
      to={item.to}
      style={linkStyle}
      onMouseEnter={e => { e.currentTarget.style.color = "var(--orange)"; }}
      onMouseLeave={e => { e.currentTarget.style.color = "var(--paper)"; }}
    >
      {item.label}
    </Link>
  );
}

function DiscordIcon() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
      <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057c.002.022.015.043.032.054a19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418Z"/>
    </svg>
  );
}

export default function SiteFooter() {
  return (
    <footer className="site-footer">
      {/* Discord banner */}
      <div className="footer-discord-banner">
        <div className="footer-discord-left">
          <span className="mono footer-discord-eyebrow">◆ COMMUNITY</span>
          <p className="footer-discord-heading">
            Join us on Discord for exclusive updates, industry news &amp; giveaways.
          </p>
        </div>
        <a
          href={DISCORD_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="footer-discord-btn"
        >
          <DiscordIcon />
          Join Discord
        </a>
      </div>

      <div className="site-footer-inner">
        <div className="site-footer-grid">
          <div>
            <LogoInline size={0.85} />
            <p style={{
              marginTop: 14,
              fontSize: 13,
              color: "var(--gray)",
              lineHeight: 1.5,
              maxWidth: 320,
            }}>
              An independent criticism site. Publishing whenever someone
              finishes something worth talking about.
            </p>
          </div>

          {COLS.map(col => (
            <div key={col.title}>
              <div className="mono" style={{
                fontSize: 11,
                color: "var(--orange)",
                letterSpacing: "0.2em",
                textTransform: "uppercase",
                marginBottom: 12,
              }}>
                {col.title}
              </div>
              {col.items.map(item => (
                <FooterLink key={item.label} item={item} />
              ))}
            </div>
          ))}
        </div>

        <div className="mono site-footer-copy">
          <span>© 2026 ROUGH CUT · ALL RIGHTS RESERVED</span>
          <span>PRINTED IN SOMEONE'S SPARE BEDROOM</span>
          <span>PAGE 01 / ∞</span>
        </div>
      </div>
    </footer>
  );
}
